import { type QuerySkeletonLayout, querySkeletonLayout } from "./pageSkeletons";

type Props = {
  error: Error | null;
  layout?: QuerySkeletonLayout;
};

// What a page shows before its queries have all answered.
export function QueryState({ error, layout = "customerDetail" }: Props) {
  return error ? (
    <p className="p-6 text-destructive text-sm" role="alert">
      {error.message}
    </p>
  ) : (
    querySkeletonLayout(layout)
  );
}
